import { type CsticId, type LinearSubstep } from "~/features/configurator/Linear/models";
import { useSelector } from "react-redux";
import SubstepFrame from "~/features/configurator/Linear/components/SubstepFrame";
import { useMinMaxLengthLabel } from "~/features/configurator/Linear/hooks/useMinMaxLengthLabel";
import LanguageAwareExternalContent from "~/features/configurator/Linear/components/LanguageAwareExternalContent";
import { useTranslation } from "react-i18next";
import { SubstepType } from "~/features/configurator/Linear/dtos";

import { SimpleCsticNumberField } from "~/features/configurator/Shaft/components/SimpleCsticNumberField";
import { selectCsticExpanded } from "~/features/configurator/Linear/redux/selectCstic";
import { Alert } from "~/common/mui/Alert/Alert";
import { KmatType } from "~/features/configurator/Linear/kmatType";
import * as UnitCstics from "~/features/configurator/Linear/v2/configuration/classic/UnitCstics";
import { styled } from "~/common/mui";

const MillimeterInput = styled("div")(({ theme }) => ({
  maxWidth: "328px",
  marginBottom: theme.spacing(3.75),
}));

interface Props {
  csticIndex: number;
  csticAmount: number;
  def: LinearSubstep;
}

const FAKE_LENGTH_CSTIC: CsticId = {
  key: UnitCstics.FakeLength,
  index: 0,
  type: KmatType.Main,
};

const LengthSubstep = ({ def, ...props }: Props) => {
  const { cstic, isDirty, isInConflict } = useSelector(selectCsticExpanded(FAKE_LENGTH_CSTIC, SubstepType.Length));

  const helperLabel = useMinMaxLengthLabel();
  const { t } = useTranslation();

  const isError = isInConflict || (isDirty && !cstic.value);
  const errMsg = isError ? t("linear.step.select.valid.value") : "";

  return (
    <SubstepFrame
      title={def.name}
      description=""
      info={def.info}
      isPicked={def.value !== null}
      showError={isError}
      errorMessage={errMsg}
      {...props}
    >
      <div>
        <MillimeterInput>
          <SimpleCsticNumberField
            label={def.name}
            csticId={FAKE_LENGTH_CSTIC}
            substepType={SubstepType.Length}
            helperLabel={helperLabel}
            error={isError}
          />
        </MillimeterInput>
        <Alert className="mb-30" severity="info">
          <LanguageAwareExternalContent content={def.footerInfo[0]} className={"scha__lc__external-label"} />
        </Alert>
      </div>
    </SubstepFrame>
  );
};
export default LengthSubstep;
